import { createState } from './state.js';
import { AudioEngine } from './audio/engine.js';
import { Keyboard } from './ui/keyboard.js';
import { buildPanels } from './ui/panels.js';
import { buildPresetSelector, loadDefaultPreset } from './ui/presets-ui.js';
import { CosmicScene } from './visual/scene.js';
import { Oscilloscope } from './visual/oscilloscope.js';
import { Spectrum } from './visual/spectrum.js';

// Initialize state
const state = createState();

// Audio engine
const engine = new AudioEngine(state);

// Visuals (created immediately so background renders)
const cosmicCanvas = document.getElementById('cosmic-canvas');
const cosmicScene = new CosmicScene(cosmicCanvas);

const oscCanvas = document.getElementById('oscilloscope');
const specCanvas = document.getElementById('spectrum');
const oscilloscope = new Oscilloscope(oscCanvas);
const spectrum = new Spectrum(specCanvas);

// Note-triggered particles
engine.onNoteOn((note) => {
  cosmicScene.emitParticles(note);
});

// UI panels
const panelsContainer = document.getElementById('control-panels');
buildPanels(panelsContainer, state);

// Preset selector
const presetSelect = document.getElementById('preset-select');
buildPresetSelector(presetSelect, state);

// Load default preset
loadDefaultPreset(state);

// Keyboard
const keyboardContainer = document.getElementById('keyboard-container');
const keyboard = new Keyboard(keyboardContainer, engine);

// Animation loop
function animate() {
  requestAnimationFrame(animate);

  const waveform = engine.getWaveformData();
  const fft = engine.getFFTData();

  cosmicScene.update(waveform, fft);
  oscilloscope.draw(waveform);
  spectrum.draw(fft);
}
animate();

// Start overlay - required for Web Audio API
const overlay = document.getElementById('start-overlay');
const startBtn = document.getElementById('start-button');

startBtn.addEventListener('click', async () => {
  await engine.start();
  overlay.classList.add('hidden');
});

// Also start on any keypress
document.addEventListener('keydown', async (e) => {
  if (!engine.started && !overlay.classList.contains('hidden')) {
    await engine.start();
    overlay.classList.add('hidden');
  }
}, { once: false });
